/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { Link } from '../../Link/Link';
import { Text } from '@getgo/chameleon-chakra-ui';
import { isMobileJoinTechnicallySupported } from '../../../services/ProductCompatibilityService';

interface Props {
  link: string;
  linkText: string;
  color?: string;
  breakWords?: boolean;
}

export const FooterListItem: React.FC<Props> = ({
  link,
  linkText,
  color = 'inherit',
  breakWords,
}) => {
  const fontSize = isMobileJoinTechnicallySupported ? '0.6rem' : '0.75rem';
  const wordBreak = breakWords ? 'break-word' : 'normal';
  return (
    <Link href={link} isExternal={true} color={color}>
      <Text
        textTransform='uppercase'
        fontSize={fontSize}
        px={2}
        letterSpacing='widest'
        wordBreak={wordBreak}
      >
        {linkText}
      </Text>
    </Link>
  );
};
